import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import TableView from '../TableView';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Supplier = () => {
    // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
    const [baseUrl, setBaseUrl] = useState('http://mol.evolve-demo.com/api/');
    const [pageComponent, setPageComponent] = useState('supplier');
    const [data, setData] = useState(undefined);
    const [supCode, setSupCode] = useState('');
    const [supName, setSupName] = useState('');
    const [shortName, setShortName] = useState('');
    const [eMail, setEMail] = useState('');
    const [phoneNo1, setPhoneNo1] = useState('');
    const [phoneNo2, setPhoneNo2] = useState('');
    const [fax, setFax] = useState('');
    const [web, setWeb] = useState('');
    const [contactPerson, setContactPerson] = useState('');
    const [contactPersonContNO, setContactPersonContNO] = useState('');
    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine2, setAddressLine2] = useState('');
    const [addressLine3, setAddressLine3] = useState('');
    const [addressLine4, setAddressLine4] = useState('');
    const [city, setCity] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [stateProv, setStateProv] = useState('');
    const [country, setCountry] = useState('');
    const [gLacc, setGLacc] = useState('');
    const [payTerm, setPayTerm] = useState('');
    const [paytermList, setPaytermList] = useState(undefined);
    const [btnActive, setBtnActive] = useState(true);
    const [selectRowData, setSelectRowData] = useState('');
    const [emptyInput, setEmptyInput] = useState(false);
    const [emptySupCode, setEmptySupCode] = useState(false);
    const [emptySupName, setEmptySupName] = useState(false);
    const [emptyShortName, setEmptyShortName] = useState(false);
    const [emptyEmail, setEmptyEmail] = useState(false);
    const [emptyPhone, setEmptyPhone] = useState(false);
    const [emptyFax, setEmptyFax] = useState(false);
    const [emptyContactPerson, setEmptyContactPerson] = useState(false);
    const [emptyAddress, setEmptyAddress] = useState(false);
    const [emptyCity, setEmptyCity] = useState(false);
    const [emptyPostalCode, setEmptyPostalCode] = useState(false);
    const [emptyStateProv, setEmptyStateProv] = useState(false);
    const [emptyCountry, setEmptyCountry] = useState(false);
    const [emptyPaytermList, setEmptyPaytermList] = useState(false);
    const [emptyContactPersonContNO, setEmptyContactPersonContNO] = useState(false);
    const [emptyGLacc, setemptyGLacc] = useState(false);

    function setSelectedRow(rowid) {
        const currunt_ID = rowid;
        console.log(currunt_ID);
        axios.get(`${baseUrl}${pageComponent}/show/${currunt_ID}`).then(res => {
            const selectRowData = res.data;
            console.log(selectRowData.supplier.Vendor_id);
            console.log(selectRowData.supplier.Pay_term);
            setSelectRowData(selectRowData);
            setSupCode(selectRowData.supplier.Vendor_id ? selectRowData.supplier.Vendor_id : '');
            setSupName(selectRowData.supplier.Vendor_name ? selectRowData.supplier.Vendor_name : '');
            setShortName(selectRowData.supplier.Short_name ? selectRowData.supplier.Short_name : '');
            setEMail(selectRowData.supplier.email ? selectRowData.supplier.email : '');
            setPhoneNo1(selectRowData.supplier.telephone_1 ? selectRowData.supplier.telephone_1 : '');
            setPhoneNo2(selectRowData.supplier.telephone_2 ? selectRowData.supplier.telephone_: '');
            setFax(selectRowData.supplier.Fax ? selectRowData.supplier.Fax : '');
            setWeb(selectRowData.supplier.web ? selectRowData.supplier.web : '');
            setContactPerson(selectRowData.supplier.Contact_person ? selectRowData.supplier.Contact_person : '');
            setAddressLine1(selectRowData.supplier.Address_line_1 ? selectRowData.supplier.Address_line_1 : '');
            setAddressLine1(selectRowData.supplier.Address_line_2 ? selectRowData.supplier.Address_line_2 : '');
            setAddressLine1(selectRowData.supplier.Address_line_3 ? selectRowData.supplier.Address_line_3 : '');
            setAddressLine1(selectRowData.supplier.Address_line_4 ? selectRowData.supplier.Address_line_4 : '');
            setCity(selectRowData.supplier.City ? selectRowData.supplier.City : '');
            setPostalCode(selectRowData.supplier.Postal_code ? selectRowData.supplier.Postal_code : '');
            setStateProv(selectRowData.supplier.state_prov ? selectRowData.supplier.state_prov : '');
            setCountry(selectRowData.supplier.Country ? selectRowData.supplier.Country : '');
            setContactPersonContNO(selectRowData.supplier.Contper_no ? selectRowData.supplier.Contper_no : '');
            setGLacc(selectRowData.supplier.GL_acc ? selectRowData.supplier.GL_acc : '');
            setPayTerm(selectRowData.supplier.Pay_term ? selectRowData.supplier.Pay_term : '');
            setBtnActive(false);
        })
    }

    const createNewRow = () => {
        setBtnActive(false);
        setSelectRowData('');
    }

    useEffect(() => {
        fetch(`${baseUrl}${pageComponent}/dropdown`)
            .then(response => response.json())
            .then(data => {
                setPaytermList(data.payterm);
                // console.log(data.payterm);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const handleSave = async (event) => {
        event.preventDefault();

        if (supCode.length == 0) {
            toast.error("Supplier Code can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptySupCode(true);
            setEmptyInput(true);
        } else {
            setEmptySupCode(false);
        }

        if (supName.length == 0) {
            toast.error("Supplier Name can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptySupName(true);
            setEmptyInput(true);
        } else {
            setEmptySupName(false);
        }


        if (shortName.length == 0) {
            toast.error("Supplier ShortName can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyShortName(true);
            setEmptyInput(true);
        } else {
            setEmptyShortName(false);
        }

        if (eMail.length == 0) {
            toast.error("Supplier Email can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyEmail(true);
            setEmptyInput(true);
        } else {
            setEmptyEmail(false);
        }

        if (phoneNo1.length == 0) {
            toast.error("Supplier Phone number can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyPhone(true);
            setEmptyInput(true);
        } else {
            setEmptyPhone(false);
        }

        if (fax.length == 0) {
            toast.error("Supplier Fax number can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyFax(true);
            setEmptyInput(true);
        } else {
            setEmptyFax(false);
        }

        if (addressLine1.length == 0) {
            toast.error("Supplier Address can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyAddress(true);
            setEmptyInput(true);
        } else {
            setEmptyAddress(false);
        }

        if (contactPerson.length == 0) {
            toast.error("Contact Person can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyContactPerson(true);
            setEmptyInput(true);
        } else {
            setEmptyContactPerson(false);
        }

        if (city.length == 0) {
            toast.error("Supplier City can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyCity(true);
            setEmptyInput(true);
        } else {
            setEmptyCity(false);
        }

        if (postalCode.length == 0) {
            toast.error("Postal code can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyPostalCode(true);
            setEmptyInput(true);
        } else {
            setEmptyPostalCode(false);
        }

        if (stateProv.length == 0) {
            toast.error("State/Prov can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyStateProv(true);
            setEmptyInput(true);
        } else {
            setEmptyStateProv(false);
        }

        if (country.length == 0) {
            toast.error("Country can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyCountry(true);
            setEmptyInput(true);
        } else {
            setEmptyCountry(false);
        }

        if (paytermList.length == 0) {
            toast.error("Payment Term can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyPaytermList(true);
            setEmptyInput(true);
        } else {
            setEmptyPaytermList(false);
        }

        if (contactPersonContNO.length == 0) {
            toast.error("Payment Term can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyContactPersonContNO(true);
            setEmptyInput(true);
        } else {
            setEmptyContactPersonContNO(false);
        }

        if (gLacc.length == 0) {
            toast.error("Payment Term can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setemptyGLacc(true);
            setEmptyInput(true);
        } else {
            setemptyGLacc(false);
        }

        if (emptyInput !== true) {
            const inputData = { Vendor_id: supCode, Short_name: shortName, Vendor_name: supName, Address_line_1: addressLine1, Address_line_2:addressLine2, Address_line_3 : addressLine3, Address_line_4: addressLine4, City: city, state_prov: stateProv, Postal_code: postalCode, Country: country, telephone_1: phoneNo1, telephone_2: phoneNo2, Fax: fax, email: eMail, web: web, Contact_person: contactPerson, Contper_no: contactPersonContNO, GL_acc: gLacc, Pay_term: payTerm };
            const duplicate = await data.some(el => el.Vendor_id == supCode);
            if (duplicate !== true) {

                axios.post(`${baseUrl}${pageComponent}/store`, inputData)
                    .then(response => {
                        toast.success('Successfully Save Data ! ', {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setTimeout(window.location.reload.bind(window.location), 2000);

                    })
                    .catch(error => {
                        console.error(error);
                    });
            } else {

                toast.error("This currency code already included", {
                    position: toast.POSITION.TOP_RIGHT
                })


            }
        } else {

        }
 
    }

    const edditRow = (event) => {
        event.preventDefault();
        if (selectRowData !== '') {
            const inputData = { Vendor_id: supCode, Short_name: shortName, Vendor_name: supName, Address_line_1: addressLine1, Address_line_2:addressLine2, Address_line_3 : addressLine3, Address_line_4: addressLine4, City: city, state_prov: stateProv, Postal_code: postalCode, Country: country, telephone_1: phoneNo1, telephone_2: phoneNo2, Fax: fax, email: eMail, web: web, Contact_person: contactPerson, Contper_no: contactPersonContNO, GL_acc: gLacc, Pay_term: payTerm };
            axios.post(`${baseUrl}${pageComponent}/${selectRowData.supplier.id}/update`, inputData)
                .then(response => {
                    toast.success('Successfully Save Data ! ', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    setTimeout(window.location.reload.bind(window.location), 2000);
                })
                .catch(error => {
                    console.error(error);
                });
        } else {
            toast.error("Please Select data Row", {
                position: toast.POSITION.TOP_RIGHT
            })
        }
    }

    const deleteRow = (event) => {
        event.preventDefault();
        console.log(selectRowData.supplier.id);
        axios.delete(`${baseUrl}${pageComponent}/${selectRowData.supplier.id}/destroy`, selectRowData.supplier.id)
        toast.warning('Successfully Deleted Data Row', {
            position: toast.POSITION.TOP_RIGHT
        });
        setTimeout(window.location.reload.bind(window.location), 2000);
    }

    useEffect(() => {
        fetch(`${baseUrl}${pageComponent}/index`)
            .then(response => response.json())
            .then(data => {
                setData(data.supplier);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const columns = ['Vendor_id', 'Short_name', 'Vendor_name', 'Address', 'City', 'state_prov', 'Postal_code', 'Country', 'Phone_no', 'Fax', 'email', 'web', 'Contact_person', 'GL_acc', 'Pay_term'];
    return (
        <Container>
            <ToastContainer autoClose={2000} />
            <Row>
                <Col>
                    <Form className='mt-3 bottom-border pb-3'>
                        <Row >
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Code</Form.Label>
                                    <Form.Control type="text" readOnly={selectRowData !== '' ? true : false} className={emptySupCode == true ? 'border-red2' : ''} placeholder="" value={supCode} onChange={e => setSupCode(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control type="text" placeholder="" value={supName} className={emptySupName == true ? 'border-red2' : ''} onChange={e => setSupName(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Short Name</Form.Label>
                                    <Form.Control type="text" placeholder="ORIT TRADI" value={shortName} className={emptyShortName == true ? 'border-red2' : ''} onChange={e => setShortName(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control type="email" placeholder="" value={eMail} className={emptyEmail == true ? 'border-red2' : ''} onChange={e => setEMail(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Telephone 1</Form.Label>
                                    <Form.Control type="phone" placeholder="0001" value={phoneNo1} className={emptyPhone == true ? 'border-red2' : ''} onChange={e => setPhoneNo1(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Telephone 2</Form.Label>
                                    <Form.Control type="phone" placeholder="0001" value={phoneNo2}  onChange={e => setPhoneNo2(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row >
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Fax</Form.Label>
                                    <Form.Control type="phone" placeholder="" value={fax} className={emptyFax == true ? 'border-red2' : ''} onChange={e => setFax(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Web Site</Form.Label>
                                    <Form.Control type="text" placeholder="" value={web} onChange={e => setWeb(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Contact Person</Form.Label>
                                    <Form.Control type="text" placeholder="" value={contactPerson} className={emptyContactPerson== true ? 'border-red2' : ''} onChange={e => setContactPerson(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Address</Form.Label>
                                    {/* <Form.Control as="textarea" placeholder="Address here" value={address} className={emptyAddress == true ? 'border-red2' : ''} onChange={e => setAddress(e.target.value)} /> */}
                                    <Form.Control type="text" placeholder="" value={addressLine1} className={emptyAddress == true ? 'border-red2' : ''} onChange={e => setAddressLine1(e.target.value)} />
                                    <Form.Control type="text" placeholder="" value={addressLine2} onChange={e => setAddressLine2(e.target.value)} />
                                    <Form.Control type="text" placeholder="" value={addressLine3} onChange={e => setAddressLine3(e.target.value)} />
                                    <Form.Control type="text" placeholder="" value={addressLine4} onChange={e => setAddressLine4(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control type="text" placeholder="" value={city} className={emptyCity == true ? 'border-red2' : ''} onChange={e => setCity(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row >
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Postal Code</Form.Label>
                                    <Form.Control type="text" placeholder="" value={postalCode} className={emptyPostalCode == true ? 'border-red2' : ''} onChange={e => setPostalCode(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>State/Prov</Form.Label>
                                    <Form.Control type="text" placeholder="" value={stateProv} className={emptyStateProv == true ? 'border-red2' : ''} onChange={e => setStateProv(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Country</Form.Label>
                                    <Form.Control type="text" placeholder="" value={country} className={emptyCountry == true ? 'border-red2' : ''} onChange={e => setCountry(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Payment Term</Form.Label>
                                    <Form.Select aria-label="Default select example" className={emptyPaytermList == true ? 'border-red2' : ''} onChange={e => setPayTerm(e.target.value)}>

                                    {payTerm !== '' ?
                                            <>
                                                <option value={payTerm} >{payTerm}</option>
                                               
                                                {paytermList !== undefined ? paytermList.map(paytermItem => (
                                                    paytermItem.PaymentTerm !== payTerm ? 
                                                        <option value={paytermItem.PaymentTerm} key={paytermItem.id}>{paytermItem.PaymentTerm}</option>
                                                        : ''
                                                   
                                                )) : ''}
                                            </>
                                            :
                                            <>
                                                <option value={payTerm} >{payTerm}</option>
                                                {paytermList !== undefined ? paytermList.map(paytermItem => (

                                                    <option value={paytermItem.PaymentTerm} key={paytermItem.id}>{paytermItem.PaymentTerm}</option>
                                                )) : ''}
                                            </>
                                        }

                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Contact Telephone</Form.Label>
                                    <Form.Control type="text" placeholder="" value={contactPersonContNO} className={emptyContactPersonContNO == true ? 'border-red2' : ''} onChange={e => setContactPersonContNO(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>GL Account</Form.Label>
                                    <Form.Control type="text" placeholder="" value={gLacc} className={emptyGLacc == true ? 'border-red2' : ''} onChange={e => setGLacc(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='text-center mt-3'>
                            <Col>
                                <Form className="d-flex">
                                    <Form.Control
                                        type="search"
                                        placeholder="Search"
                                        className="me-2"
                                        aria-label="Search"
                                    />
                                    <Button className="ms-3" variant="primary" type="submit">
                                        Search
                                    </Button>
                                </Form>
                            </Col>
                            <Col className='text-end'>
                            <Button className="ms-3" variant="primary" onClick={selectRowData !== '' ? edditRow : handleSave} disabled={btnActive}>
                                    Save
                                </Button>

                                <Button className="ms-3" variant="primary" onClick={createNewRow}>
                                    New
                                </Button>

                                <Button className="ms-3" variant="primary" onClick={edditRow} disabled={btnActive}>
                                    Update
                                </Button>
                                <Button className="ms-3" variant="primary" onClick={deleteRow} disabled={btnActive}>
                                    Delete
                                </Button>

                                <Button className="ms-3" variant="primary" disabled={btnActive}>
                                    Print
                                </Button>

                                <Button className="ms-3" variant="primary" type="submit">
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                    <TableView data={data} columns={columns} setSelectedRow={setSelectedRow} />
                </Col>
            </Row>
        </Container>
    );
}

export default Supplier;